
var React = require('react');

module.exports = function() {
  return React.createElement(
	"svg",
	{ viewBox: "0 0 64 64" },
	React.createElement("path", { d: "m13.8 22.5c-4.4-4.4-5.8-8.1-4.2-10.9 3.1-5.5 18-5.5 30.4-2.7l-.4 1.8c-11.6-2.5-25.7-2.6-28.3 1.9-1.4 2.5 1.3 6.1 3.9 8.7l-1.4 1.2", fill: "#d3976e" }),
	React.createElement(
		"g",
		{ fill: "#ffce31" },
		React.createElement("path", { d: "m41.2 11.3c-1 1-2 1.9-2.9 2.9-.9.9.5 2.2 1.3 1.3 1-1 2-1.9 2.9-2.9.9-.8-.4-2.2-1.3-1.3" }),
		React.createElement("path", { d: "m46.8 8.5c1-1 1.9-1.9 2.9-2.9.9-.9-.5-2.2-1.3-1.3-1 1-1.9 1.9-2.9 2.9-.9.8.4 2.1 1.3 1.3" }),
		React.createElement("path", { d: "m45.4 12.6c1 1 2 1.9 2.9 2.9.9.9 2.2-.5 1.3-1.3-1-1-2-1.9-2.9-2.9-.8-.9-2.2.5-1.3 1.3" }),
		React.createElement("path", { d: "m38.3 5.6c1 1 1.9 1.9 2.9 2.9.9.9 2.2-.5 1.3-1.3-1-1-1.9-1.9-2.9-2.9-.8-.9-2.2.5-1.3 1.3" })
	),
	React.createElement(
		"g",
		{ fill: "#ed4c5c" },
		React.createElement("path", { d: "m43 14c0 1 0 1.9 0 2.9 0 1.2 1.9 1.2 1.9 0 0-1 0-1.9 0-2.9 0-1.2-1.9-1.2-1.9 0" }),
		React.createElement("path", { d: "m43 2.9c0 .9 0 1.9 0 2.8 0 1.2 1.9 1.2 1.9 0 0-.9 0-1.9 0-2.8 0-1.2-1.9-1.2-1.9 0" }),
		React.createElement("path", { d: "m48.2 10.8c1 0 1.9 0 2.9 0 1.2 0 1.2-1.9 0-1.9-1 0-1.9 0-2.9 0-1.2.1-1.2 1.9 0 1.9" })
	),
	React.createElement("path", { d: "m10.7 24.2l6-5.9 3.8 3.7c3.5-2.4 7.8-3.7 12.4-3.7 12.2-.1 22.1 9.7 22.1 21.8 0 12.1-9.9 21.9-22.2 21.9-12.2 0-22.2-9.8-22.2-21.9 0-4.5 1.4-8.7 3.8-12.2l-3.7-3.7", fill: "#3e4347" })
);
};



//////////////////
// WEBPACK FOOTER
// ./~/react-svg-emojione/dist/bomb.js
// module id = 685
// module chunks = 0